"use strict";

/* Controllers */

angular
    .module("BannerFlowApp")
    .controller(
        "SideBarController",
        function SideBarController($scope, $rootScope, $state, AuthInfo, Utils, FeatureFlagService) {
            $scope.model = {
                analyticsLink: "analytics"
            };

            $scope.Utils = Utils;

            $scope.updateParams = function () {
                $scope.model.analyticsLink = "analytics";
            };
            $rootScope.$on("$stateChangeSuccess", $scope.updateParams);

            $scope.updateParams();

            $scope.showSidebarItem = function (featureConstant) {
                const hasFeature = $scope.hasFeature(featureConstant);

                switch (featureConstant) {
                    case $rootScope.FEATURE_LANDINGPAGE:
                    case $rootScope.FEATURE_FEEDS:
                    case $rootScope.FEATURE_ANALYTICS:
                        return hasFeature;
                    case $rootScope.FEATURE_SOCIALCAMPAIGNMANAGER:
                        return hasFeature;
                    case $rootScope.FEATURE_SOCIALDYNAMICADVERTISING:
                        return hasFeature;
                    case $rootScope.FEATURE_CAMPAIGNMANAGER:
                        return hasFeature && $scope.hasFeature($rootScope.FEATURE_STUDIO);
                    default:
                        return true;
                }
            };

            $scope.hasFeature = function (featureConstant) {
                return AuthInfo.HasFeatures([featureConstant]);
            };

            $scope.canUseCampaignManager = function () {
                return AuthInfo.CanUseCampaignManager();
            };

            $scope.expandMenu = function () {
                $rootScope.isMenuExpanded = !$rootScope.isMenuExpanded;
            };

            $scope.navigateToCampaigns = function () {
                const isCampaignNUIEnabled = FeatureFlagService.isEnabled("Campaign-CLV-NUI");

                if (isCampaignNUIEnabled) {
                    Utils.GotoV2Url("campaigns-nui");
                } else {
                    Utils.GotoV2Url("campaigns");
                }
            };

            $scope.navigateToLandingPages = function () {
                const isBfcNUIEnabled = FeatureFlagService.isEnabled("BFC-NUI");

                if (isBfcNUIEnabled) {
                    Utils.GotoV2Url("landingpages");
                } else {
                    $state.go("root.landingpages");
                }
            };

            $scope.navigateToFeeds = function () {
                const isLegacyFeedsEnabled = FeatureFlagService.isEnabled("BFC-LegacyFeeds");

                if (isLegacyFeedsEnabled) {
                    Utils.GotoV2Url("feeds");
                } else {
                    $state.go("root.feeds");
                }
            };
        }
    );
